import React from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Info, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Inquiry } from 'models/InquiryModel';

const InquiryForm: React.FC = () => {
  const [formId, formName] = [Code.Form.Id.INQUIRY, Code.Form.Name.INQUIRY];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [cityOptions, setCityOptions] = Hooks.Form.Options();
  const [typeOptions, setTypeOptions] = Hooks.Form.Options();
  const [responseOptions, setResponseOptions] = Hooks.Form.Options();
  const [interestOptions, setInterestOptions] = Hooks.Form.Options();
  const [contactOptions, setContactOptions] = Hooks.Form.Options();
  const [statusOptions, setStatusOptions] = Hooks.Form.Options();
  const [formData, setFormData] = useState<Inquiry>({});
   
  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasOpen(Privilege);
  
  useEffect(() => {
    Files.Json.API(Code.File.CITY, Code.Option.Common.NA, setCityOptions, setError);
    Files.Json.API(Code.File.OPTION+Code.Group.INQUIRY_TYPE, Code.Option.Common.NA, setTypeOptions, setError);
    Files.Json.API(Code.File.OPTION+Code.Group.INQUIRY_STATUS, Code.Option.Common.NA, setStatusOptions, setError);
    Files.Json.API(Code.File.OPTION+Code.Group.INQUIRY_INTERESTED, Code.Option.Common.SELECT, setInterestOptions, setError);
    Files.Json.API(Code.File.OPTION+Code.Group.INQUIRY_RESPONSE, Code.Option.Common.NA, setResponseOptions, setError);
    Files.Json.API(Code.File.OPTION+Code.Group.INQUIRY_CONTACT, Code.Option.Common.NOTHING, setContactOptions, setError);
   
    API.Data.GetByKeyId<Inquiry>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        setActiveId(data.inquiry_active); 
        const formData = await Form.Map.Data(data);
        setFormData((prevData) => ({
          ...prevData,
          ...formData,
        }));
      }})
      setLoading(false);
  }, []);

  const onSubmit = async (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e,setMessage)) return;
    const addonData = await API.Data.AddonData(formData, formName, keyId);
    const finalData = Utility.Sanitize.FormData({
      ...formData,
      ...addonData,
      user_phone: Utility.Convert.Number(formData.user_phone),
    });

    API.Data.Save(formName, keyId, finalData, setMessage)
  };

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} clientNumber={formData.client_number} formName={formName} Privilege={Privilege} />
          <Control.Tab.Header titles={["Inquiry"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
          
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Row>
                <Field.Select id={Name.Inquiry.InterestId} value={formData.interest_id} title="Interested" options={interestOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)}  size={[0,50,1]} require={true} />
                <Field.Date id={Name.Inquiry.Date} value={formData.inquiry_date} title={Title.Date} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} require={true} currentDate={true} />
              </Control.Row>
              <Control.Row>
                <Field.Text id={Name.Inquiry.Name} value={formData.inquiry_name} title={Title.ClientName} onChange={(e) => Form.Field.Change(e, formData, setFormData)} require={true} />
              </Control.Row>
              <Control.Row>
                <Field.Text id={Name.Inquiry.Phone} value={Utility.Format.Phone(formData.inquiry_phone)} title={Title.Phone} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} />
                <Field.Text id={Name.Inquiry.Email} value={formData.inquiry_email} title={Title.Email} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]}  />
              </Control.Row>
              <Control.Row>
                <Field.Area id={Name.Inquiry.Address} value={formData.inquiry_address} title={Title.Address} onChange={(e) => Form.Field.Change(e, formData, setFormData)} />
              </Control.Row>
              <Control.Row>
                <Field.Select id={Name.City.Id} value={formData.city_id} title={Title.City} options={cityOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)}  size={[0,50,1]}  />
                <Field.Text id={Name.Inquiry.Postal} value={formData.inquiry_postal} title={Title.Postal} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} />
              </Control.Row>
              <Control.Row>
                <Field.Area id={Name.Inquiry.Comment} value={formData.inquiry_comment} title={Title.Comment} onChange={(e) => Form.Field.Change(e, formData, setFormData)} />
              </Control.Row>
              <Control.Row>
                <Field.Select id={Name.Common.TypeId} value={formData.type_id} title={Title.Type} options={typeOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)}  size={[0,50,1]} />
                <Field.Select id={Name.Inquiry.ResponseId} value={formData.response_id} title="Response" options={responseOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)}  size={[1,50,0]} />
              </Control.Row>
              <Control.Row>
              <Field.Select id={Name.Common.StatusId} value={formData.status_id} title={Title.Status} options={statusOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} />
              <Field.Select id={Name.Common.ContactMode} value={formData.contact_mode_id} title="Prefer to contact" options={contactOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} />
              </Control.Row>
            </Control.Tab.Content>
          
          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName}  handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default InquiryForm;